import PropTypes from 'prop-types';
import React from 'react';
import {useDownload} from '../../hooks/useDownload';

const CTASignUp = ({
        returnUrl,
        info,
        ctaString,
        ...props
    }) => {

    const download = useDownload(info);

    return (
        <div role="button" tabIndex="0" className="appleStore" onClick={download} alt={ctaString} />
    );
};

CTASignUp.propTypes = {
    history: PropTypes.object,
    ctaString: PropTypes.string,
    returnUrl: PropTypes.string,
    info: PropTypes.object
}

export default CTASignUp;
